import React from 'react';
import ProgressBar from '../../app/ProgressBar/ProgressBar.jsx';
import './CourseCompletion.less';
import { observer } from 'mobx-react';

const CourseCompletion = observer(['lectures', 'enrollments'], ({enrollments, courseId}) => {
  const enrollment = enrollments.courses.get(courseId);
  return (enrollment) ? (
    <div className="course-completion">
      <h2 className="text-center m-b">Your current status ({enrollment.lecturesCompleted}/{enrollment.lecturesCount} completed)</h2>
      <ProgressBar percentage={ enrollment.percentage } />
    </div>
  ) : null;
});

export default CourseCompletion;

//Unit test entry point
export const CourseCompletionTest = CourseCompletion;


/** WEBPACK FOOTER **
 ** ./src/js/course/CourseCompletion/CourseCompletion.jsx
 **/